import { CommonFeatureStates, EXPRESSIONS } from "../variables/expressions";
import { CUSTOMIZABLE_VALUES, generatedMapStyleJSON, getStyleIdExpressions, getDefaultValue, getFeatureStateStyleIdExpressions, } from "../variables/layerStylingValues";
/** This one gets the really custom colors for the buildings, with completely custom names.
 * Tough it is supposed to react to a styleId like all others, so this is just legacy and should be removed soon.
 * @deprecated
 */
const getCustomBuildingColors = () => {
    var _a;
    const buildingPolygonColors = [];
    (_a = CUSTOMIZABLE_VALUES.buildingPolygonColors) === null || _a === void 0 ? void 0 : _a.forEach((b) => {
        buildingPolygonColors.push([
            "==",
            // look into object "additionalData" -> and get -> "class" from there
            ["get", "class"],
            b.class,
        ]);
        buildingPolygonColors.push(b.color);
    });
    return buildingPolygonColors;
};
export const getBuildingGeoJSONProperties = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ({
        layout: {
            visibility: "visible",
        },
        paint: {
            "fill-extrusion-height": [
                "case",
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.height, generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings.polygons.heights_active),
                ...getStyleIdExpressions((_b = (_a = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings) === null || _a === void 0 ? void 0 : _a.polygons) === null || _b === void 0 ? void 0 : _b.heights),
                EXPRESSIONS.type.gebaude,
                ["get", "height"],
                (_e = getDefaultValue((_d = (_c = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings) === null || _c === void 0 ? void 0 : _c.polygons) === null || _d === void 0 ? void 0 : _d.heights)) !== null && _e !== void 0 ? _e : 20,
            ],
            "fill-extrusion-color": [
                "case",
                // EXPRESSIONS.buildingStates.fillColor_check,
                // EXPRESSIONS.buildingStates.fillColor,
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.fillColor, (_g = (_f = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings) === null || _f === void 0 ? void 0 : _f.polygons) === null || _g === void 0 ? void 0 : _g.colors_active),
                /** Selected State should be replaced by styleid.
                 * Also parkplatz should be removed, Everything should be styled by just the three funcitons
                 * @deprecated
                 */
                EXPRESSIONS.state.selected,
                CUSTOMIZABLE_VALUES.building_selected,
                EXPRESSIONS.type.parkplatz,
                CUSTOMIZABLE_VALUES.parking,
                ...getStyleIdExpressions((_j = (_h = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings) === null || _h === void 0 ? void 0 : _h.polygons) === null || _j === void 0 ? void 0 : _j.colors),
                ...getCustomBuildingColors(),
                // nachdem ein feature-state geändert wurde können keine genesteten Props mehr
                // verwendet werden
                // https://github.com/mapbox/mapbox-gl-js/issues/7194
                /** @deprecated These things should also be removed in the future, when everything comes with the styleId */
                EXPRESSIONS.buildingClass.normal,
                CUSTOMIZABLE_VALUES.building_normal,
                EXPRESSIONS.buildingClass.parkingGarage,
                CUSTOMIZABLE_VALUES.building_parkingGarage,
                EXPRESSIONS.buildingClass.parkingLot,
                CUSTOMIZABLE_VALUES.building_parkingLot,
                EXPRESSIONS.buildingClass.main,
                CUSTOMIZABLE_VALUES.building_main,
                // fallback
                (_m = getDefaultValue((_l = (_k = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings) === null || _k === void 0 ? void 0 : _k.polygons) === null || _l === void 0 ? void 0 : _l.colors)) !== null && _m !== void 0 ? _m : CUSTOMIZABLE_VALUES.building,
            ],
        },
    });
};
